module.exports = __webpack_public_path__ + "static/thumbnail_eigopedia_desktop-2c9b514a344604dc2fbe66e8ef46e192.png";